import { Typography } from '@creditas-ui/react'
import React from 'react'
import { formatDate, formatHour } from 'shared/helpers'
import {
  CardHeaderResumeStyle,
  MetaHeader,
  SlugStep,
} from './CardHeaderResume.style'

const CardHeaderResume = ({
  lastUpdate,
  currentStep,
  totalSteps,
  ...props
}) => {
  return (
    <CardHeaderResumeStyle component="div" {...props}>
      <MetaHeader>
        <Typography
          color="neutral.80"
          mb="4px"
          component="h2"
          variant="bodyMdMedium"
        >
          Última atualização
        </Typography>
        <Typography color="neutral.80" component="p" variant="bodyXsRegular">
          {`${formatDate(lastUpdate)} às ${formatHour(lastUpdate)}`}
        </Typography>
      </MetaHeader>
      <SlugStep>
        <Typography
          color="neutral.80"
          component="span"
          variant="bodyXsRegular"
          data-testid="slug-step-text"
        >
          Etapa{' '}
          <Typography component="span" variant="bodyXsBold" color="neutral.80">
            {currentStep}
          </Typography>{' '}
          de {totalSteps}
        </Typography>
      </SlugStep>
    </CardHeaderResumeStyle>
  )
}

export { CardHeaderResume }
